import { BaseClient } from '../client';
import { TRevenda } from '../shopkeeper';

interface putBuyerResponse {
	id: number;
}

export const putBuyer = async (id: string, requestBody: Partial<TRevenda>) => {
	// if (process.env.NODE_ENV === 'development') {
	// 	return 1234;
	// }

	try {
		const response = await BaseClient.put<putBuyerResponse>(
			`/Admin/UpdateAdminRevenda/${id}`,
			requestBody
		).then((response) => response.data.id);

		return response;
	} catch (error) {
		throw error;
	}
};
